module.exports = __webpack_public_path__ + "static/media/karbonoa.cbfffd3e.svg";